/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/common/NewConnection.Props" />
import { IShowPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/ShowPanel.props";

export interface INewConnectionProps extends IShowPanelProps {
    disableOAuth: boolean;
    onConnectButtonClick?: () => void;
    onOAuthError?: (error: Error) => void;
}
